import React from "react";
import { Grid, Label } from "semantic-ui-react";
import moment from "moment";

const styles = {
	rowContainer: {
		backgroundColor: "#fff",
		padding: 10,
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		borderRadius: "4px",
		width: "100%",
		minHeight: 60,
		margin: "5px 13px",
	},
	column: {
		color: "#00917d",
		fontWeight: 600,
		fontSize: "0.9em",
		width: "48%",
	},
	content: {
		paddingTop: 20,
	},
};

const ConnectedUser = ({ user, centers }) => {
	return (
		<Grid.Row style={{ ...styles.rowContainer, border: user.need_help ? "red 5px solid" : "none" }} key={`connected-${user?.id}`}>
			<Grid.Column style={{ ...styles.column }}>
				<div>
					{user.assignedHelpFolders.length > 0 && (
						<div>
							<Label as="span" color="red" ribbon>
								En charge du dossier {user.assignedHelpFolders[0].folder.code}
							</Label>
						</div>
					)}
					{user.help_nurse && user.assignedHelpFolders.length === 0 && user.openedFolders.length === 0 && (
						<div>
							<Label as="span" color="green" ribbon>
								Disponible
							</Label>
						</div>
					)}
					{!user.help_nurse && !user.tracing.center && (
						<div>
							<Label as="span" color="grey" ribbon>
								En pause
							</Label>
						</div>
					)}
					{!user.help_nurse && user.tracing.center && (
						<div>
							<Label as="span" color="brown" ribbon>
								{user.tracing.center.name}
							</Label>
						</div>
					)}
					{user.openedFolders.length > 0 && user.openedFolders[0] && (
						<div>
							<Label as="span" color="orange" ribbon>
								Dossier ouvert : {user.openedFolders[0].code}
							</Label>
						</div>
					)}
				</div>
				{user.first_name} {user.last_name} <br />
				<b>Role :</b> {user.role} {user.secretary_level ? user.secretary_level : ""}
			</Grid.Column>
			<Grid.Column style={{ ...styles.column }}>
				<b>Login :</b> {user.login} - {user.email} <br />
				<b>Droits :</b> {user.rights}
				{user.tracing && user.tracing.last_assigned_date && (
					<div>
						<b>Date dernier dossier assigné :</b> {moment(user.tracing.last_assigned_date).format("DD/MM/YYYY HH:mm")}
					</div>
				)}
				{user.need_help && (
					<div style={{ color: "red" }}>
						<b>Demande de l'aide !</b>
					</div>
				)}
			</Grid.Column>
			{user.openedFolders && <Grid.Column style={{ ...styles.column }}>Dossiers ouverts : {user.openedFolders?.length}</Grid.Column>}
		</Grid.Row>
	);
};

export default ConnectedUser;
